<input type="file" (change)="onFileSelected($event)" #fileInput hidden [accept]="accept" />
<button mat-raised-button color="primary" (click)="fileInput.click()">
  {{ text }}
  <mat-icon *ngIf="icon !== ''">{{ icon }}</mat-icon>
</button>
